import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import FileUploaderSelect from "./FileUploaderSelect";
import PixelColorViewer from "./PixelColorViewer";
//

const PixelColorComponent = (props) => {
    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleDownload,
        titleChoose,
        titleLoadMore,
        titleSelect,
        titleDelete,
        titleReady,
        titleCancel,
        titleCopy,
        titleCopied,
        /* titleTrimAnotherVideo,
        titleTrim,
        titleHours,
        titleMinutes,
        titleSeconds,
        titleMilliseconds,
        titleStart,
        titleEnd,
        titleFraming,
        tip1,
        tip2 */
    } = props.attributes;

    const [imageUrl, setImageUrl] = useState("");
    const [duration, setDuration] = useState("");
    const [videoWidthExt, setVideoWidthExt] = useState("");
    const [videoHeightExt, setVideoHeightExt] = useState("");
    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [showComponent, setShowComponent] = useState("");
    const [activeTab, setActiveTab] = useState("trim");

    const handleDataChange = (
        url,
        /* duration, videoWidthExt, videoHeightExt, */ fileId,
        fileName
    ) => {
        console.log(url);
        setImageUrl(url);
        /* setDuration(duration);
        setVideoWidthExt(videoWidthExt);
        setVideoHeightExt(videoHeightExt); */
        setFileId(fileId);
        setFileName(fileName);
        setShowComponent(true);
        console.log(fileId);
    };

    const [showUploader, setShowUploader] = useState(true);

    const handleDisplayUploader = (value) => {
        setShowUploader(value);
    };

    return (
        <div>
            {showComponent && (
                <>
                    <PixelColorViewer
                        fileId={fileId}
                        fileName={fileName}
                        imageUrl={imageUrl}
                        attributes={props.attributes}
                    />
                </>
            )}

            <div style={{ marginTop: "20px" }}>
                <FileUploaderSelect
                    attributes={props.attributes}
                    componentRequestData={"ImageData"}
                    /* componentUrlUploader={'UrlUploader'} */
                    setShowComponent={setShowComponent}
                    showUploader={showUploader}
                    onDataChange={handleDataChange}
                />
            </div>
        </div>
    );
};

export default PixelColorComponent;

/* if (document.getElementById("pixel-color")) {
    const pixelColorElement = document.getElementById("pixel-color");
    const root = createRoot(pixelColorElement);
    const attributes = {
        titleDragNDropSomeFilesHereOrClickToSelectFiles:
            pixelColorElement.getAttribute(
                "titleDragNDropSomeFilesHereOrClickToSelectFiles"
            ),
        titleDownload: pixelColorElement.getAttribute("titleDownload"),
        titleChoose: pixelColorElement.getAttribute("titleChoose"),
        titleLoadMore: pixelColorElement.getAttribute("titleLoadMore"),
        titleSelect: pixelColorElement.getAttribute("titleSelect"),
        titleDelete: pixelColorElement.getAttribute("titleDelete"),
        titleDeleteAll: pixelColorElement.getAttribute("titleDeleteAll"),
        titleReady: pixelColorElement.getAttribute("titleReady"),
        titleCurrentFile: pixelColorElement.getAttribute("titleCurrentFile"),
        titleCancel: pixelColorElement.getAttribute("titleCancel"),
        titleClose: pixelColorElement.getAttribute("titleClose"),
        titleCopy: pixelColorElement.getAttribute("titleCopy"),
        titleCopied: pixelColorElement.getAttribute("titleCopied"),
        titleCurrentValue: pixelColorElement.getAttribute("titleCurrentValue"),
        titleSelectedValue:
            pixelColorElement.getAttribute("titleSelectedValue"),
        tip1: pixelColorElement.getAttribute("tip1"),
        serverUploadUrl: pixelColorElement.getAttribute("serverUploadUrl"),
    };
    root.render(<PixelColorComponent attributes={attributes} />);
} */

if (document.getElementById("pixel-color")) {
    const pixelColorElement = document.getElementById("pixel-color");
    const root = createRoot(pixelColorElement);
    const attributes = { ...pixelColorElement.dataset };
    root.render(<PixelColorComponent attributes={attributes} />);
}
